import { observer } from "mobx-react";
import HeaderWrapper from "../../header/HeaderWrapper";
import { useStore } from "../../../app/stores/store";
import { useEffect } from "react";
import { Navigate } from "react-router";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";
import { Link } from "react-router";

export default observer(function UnauthorizedPage() {
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  document.title = "Base - Unauthorized";

  useEffect(() => {
    const redirectIfNotLoggedIn = async () => {
      if (!isLoggedIn) {
        return <Navigate to="/login" />;
      }
    };
    redirectIfNotLoggedIn();
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Unauthorized" }]} />
        <div className="row">
          <div id="content" className="col-md-12">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="text-center">
                <h1 style={{ fontSize: "95px" }}>Unauthorized</h1>
                <br />
                <br />
                <h2>Uh oh! page not found!</h2>
                <br />
                <h4>
                  You do not have permission to view this directory or page using the credentials that you supplied. <br />
                  Please contact your office/group administrator or tech support if you feel you have reached this message in error.
                </h4>
                <br />
                <br />
                {/*  <a href="/" className="btn btn-success-oms">Take Me Home</a> */}
                <Link to={"/"} className="btn btn-success-oms">
                  Take Me Home
                </Link>
                <br />
                <br />
              </div>
            </div>
            <div className="col-md-2"></div>
          </div>
        </div>
      </div>
    </>
  );
});
